import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.4.11_@babel+core@7.29.0_@playwright+test@1.58.2_react-dom@19.2.1_react@19.2.1__react@19.2.1_sass@1.77.4/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["CryptoConverter"] */ "/app/src/components/prices/CryptoConverter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TimeMachineSlider"] */ "/app/src/components/prices/TimeMachineSlider.tsx");
